<template>
    <div class="content" :class="visible ? 'content--visible' : ''">
        <h2>Discovering our city through data</h2>
        <p>
            <strong>The city of Melbourne is one of the world’s most liveable – but key to that liveability, is our ability to move.</strong>
        </p>
        <p>We wanted to take a closer look at how Melbourne moves, through a preliminary study leveraging transit data of morning peak hour* trips into the CBD. This way, we could get a better understanding of how certain areas of Melbourne are served by our public and private transport network.</p>
        <p>Understanding CBD access is even more powerful when considered in the context of housing affordability - and the Department of Human Services – Quarterly Rental data was mined to explore this relationship.</p>
        <p>How does your area stack up?</p>
        <p>
            <strong>Keep scrolling to explore.</strong>
        </p>
        <br>
        <p>
            <small>*Leveraging Google Maps Distance Matrix API</small>
        </p>
        <br>
        <p style="color:#aaa;font-size:70%;line-height:0.8;">
            <small>
                <b>Data Sources:</b> Travel times and optimal mode leverage the
                <a
                    href="https://cloud.google.com/maps-platform"
                >Google Maps API</a>. Rent prices sourced from
                <a
                    href="https://www.data.vic.gov.au/data/organization/department-of-health-and-human-services"
                >Department of Health and Human Services</a> bonded non-commercial rental property data in Victoria. Geospatial data and maps from the Australian Bureau of Statistics - Australian Statistical Geography Standard (ASGS).
            </small>
            <br>
            <small>
                <b>Assumptions:</b> Travel times and optimal mode are calculated by the Google Maps API during morning peak times from Google's selected area center. Google data was accessed in November 2018. Median rental pricing data is limited to two bedroom apartments in postcodes that have at 25 least rentals in the Greater Melbourne Area and is current as of March 2018.
            </small>
            <br>
            <img :src="`${baseUrl}powered_by_google_on_white.png`">
        </p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            baseUrl: process.env.BASE_URL
        };
    },
    props: {
        visible: {
            default: () => false
        }
    }
};
</script>

<style>
small a {
    font-size: 100%;
    text-transform: none;
}
</style>
